import { useEffect } from 'react';
import { useTutorialStatus } from '../hooks/useTutorialStatus';
import { markBattleOverviewModeEntered } from './markBattleOverviewModeEntered';

/** Marks a Battle Overview mode sticker as seen when the player opens that mode. */
export function useDismissBattleOverviewModeSticker(user, messageKey) {
  const { seenMessages, isLoaded, markSeenLocally } = useTutorialStatus(user);

  useEffect(() => {
    if (!user || !isLoaded || !messageKey) return;
    if (seenMessages.includes(messageKey)) return;

    markBattleOverviewModeEntered(messageKey, markSeenLocally).catch((err) => {
      console.error('Failed to dismiss battle overview mode sticker:', err);
    });
  }, [user, isLoaded, messageKey, seenMessages, markSeenLocally]);
}
